import { Injectable } from '@angular/core';

import { PlanTier } from '@shared/price-plan/enums';
import { PricePlan } from '@shared/price-plan/models';
import { FrontendModalService } from '@tablesready/frontend-modal';
import { InfoModalComponent } from '../../components';
import { PricePlansService } from './price-plans.service';

@Injectable({ providedIn: 'root' })

export class SwitchPlansRestrictionsService {
  constructor(
    private readonly modalController: FrontendModalService,
    private readonly pricePlansService: PricePlansService,
  ) {}

  unableSwitchPlans(
    currentPricePlan: PricePlan,
    newPricePlan: PricePlan,
    nonUsaOrCanadaUser: boolean,
    pricePlans: PricePlan[] = [],
  ): void {
    let recommendPlanToUpdate: PricePlan;
    let plans = this.pricePlansService.getAll();
    const tierChanged = currentPricePlan.tier !== newPricePlan.tier;
    const limitChanged = currentPricePlan.limit !== newPricePlan.limit;
    const newTerm = currentPricePlan.plan_interval_length === 1 ? 'annual' : 'monthly';
    const currentPlanLimit = currentPricePlan.limit * (nonUsaOrCanadaUser ? 10 : 1);
    const newPlanLimit = newPricePlan.limit * (nonUsaOrCanadaUser ? 10 : 1);
    const currentPlanTier = currentPricePlan.tier === PlanTier.premium ? PlanTier.business : currentPricePlan.tier;

    if (!plans.length) {
      plans = pricePlans;
    }

    if (tierChanged) {
      recommendPlanToUpdate = this.getRecommendedPlan(newPricePlan.tier, currentPlanLimit, currentPricePlan.plan_interval_length, plans);
    }

    if (limitChanged) {
      recommendPlanToUpdate = this.getRecommendedPlan(currentPlanTier, newPlanLimit, currentPricePlan.plan_interval_length, plans);
    }

    if (limitChanged && tierChanged) {
      recommendPlanToUpdate = this.getRecommendedPlan(newPricePlan.tier, newPlanLimit, currentPricePlan.plan_interval_length, plans);
    }

    this.modalController.create<InfoModalComponent, boolean>(
      InfoModalComponent,
      {
        message: `Please switch your plan ${currentPricePlan.name} to ${recommendPlanToUpdate.name} before changing your subscription term to ${newTerm}.`,
        displayButton: true,
        buttonText: 'Confirm',
      }
    ).subscribe();
  }

  private getRecommendedPlan(
    tier: PlanTier,
    limit: number,
    period: number,
    plans: PricePlan[],
  ): PricePlan {
    return plans.find(plan => plan.tier === tier && plan.limit === limit && plan.plan_interval_length === period);
  }
}
